import React from "react";
import { Route, Navigate, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Layout, Menu, Icon, Button } from "antd";
import Sider from "antd/lib/layout/Sider";
import { USER_ADMIN, USER_OWNER } from "./../utils/constants";
import { logoutUser } from "./../actions/authActions";
import logo from "./../images/logo.jpeg";
import MenuPermission from "../commons/MenuPermission";
import SubMenuPermission from "../commons/SubMenuPermission";

const { SubMenu } = Menu;
const { Content, Footer } = Layout;

const MenuComponent = ({ component: Component, auth, logoutUser, ...rest }) => {
  return (
    <Layout className="layout is-full-height">
      <Layout className="is-full-height-vh">
        <Sider
          style={{
            overflow: "auto",
            height: "100vh",
            position: "fixed",
            left: 0,
            marginTop: "0px",
          }}
        >
          <div className="logo">
            <div>
              <span>
                <img className="logo-img" src={logo} alt="logo" />
              </span>
              <div className="user-info">
                <div className="user-tag">
                  <i
                    className="fa-solid fa-user pad-right-8"
                    style={{ color: "#f58020" }}
                  ></i>

                  <span
                    style={{
                      fontSize: "10px",
                    }}
                  >
                    {auth.user.name}
                    <div>{auth?.user?.company?.name || ""}</div>
                  </span>
                </div>
                <div
                  style={{
                    fontSize: "10px",
                    fontWeight: "bold",
                    paddingTop: "10px",
                  }}
                >
                  {auth?.user.role || ""}
                </div>

                {/* <div className="has-text-weight-bold">
                <span
                  onClick={() => logoutUser()}
                  style={{
                    padding: "2px 5px",
                    fontSize: "10px",
                    marginTop: "6px",
                    color: "#fff",
                  }}
                >
                  <i className="fa-solid fa-key pad-right-8"></i>
                  Logout
                </span>
              </div> */}
              </div>
            </div>
          </div>
          <Menu key="menu" theme="dark">
            <SubMenu
              key="/masterfiles"
              title={
                <span>
                  <i className="fas fa-grip-horizontal"></i>
                  Master Files
                </span>
              }
            >
              <MenuPermission
                key="categories"
                to="/categories"
                label="Categories"
              />
              <MenuPermission key="products" to="/products" label="Products" />
              <MenuPermission
                key="menu-items"
                to="/menu-items"
                label="Menu Items"
              />
              {/* <MenuPermission key="companies" to="/companies" label="Companies" />
              <MenuPermission key="branches" to="/branches" label="Branches" /> */}
              <MenuPermission key="accounts" to="/accounts" label="Accounts" />
              <MenuPermission
                key="warehouses"
                to="/warehouses"
                label="Warehouses"
              />
              <MenuPermission
                key="payment-methods"
                to="/payment-methods"
                label="Payment Methods"
              />
              <MenuPermission key="reasons" to="/reasons" label="Reasons" />

              <MenuPermission
                key="sales-channels"
                to="/sales-channels"
                label="Sales Channels"
              />

              <MenuPermission key="banks" to="/banks" label="Banks/Source" />
              {/* <MenuPermission
                key="employees"
                to="/employees"
                label="Employees"
              /> */}
              <MenuPermission
                key="expense-categories"
                to="/expense-categories"
                label="Expense Categories"
              />
              <MenuPermission
                key="formulations"
                to="/formulations"
                label="Formulations"
              />
              <MenuPermission key="waiters" to="/waiters" label="Waiters" />
              <MenuPermission key="notes" to="/notes" label="Notes" />
              <MenuPermission
                key="condiments"
                to="/condiments"
                label="Condiments"
              />
              <MenuPermission
                key="printer-stations"
                to="/printer-stations"
                label="Printer Stations"
              />
              <MenuPermission
                key="main-categories"
                to="/main-categories"
                label="Main Categories"
              />
              <MenuPermission
                key="discounts"
                to="/discounts"
                label="Discounts"
              />
              <MenuPermission
                key="other-payments"
                to="/other-payments"
                label="Other Payments"
              />
              <MenuPermission key="branches" to="/branches" label="Branches" />
              <MenuPermission key="tieups" to="/tieups" label="Tieups" />
              <MenuPermission
                key="tieup-prices"
                to="/tieup-products"
                label="Tieup Prices"
              />
            </SubMenu>

            <SubMenu
              key="inventory"
              title={
                <span>
                  <span>
                    <i className="fas fa-folder-open"></i>
                  </span>
                  Transactions
                </span>
              }
            >
              {/* <MenuPermission
                to="/purchase-requests"
                label="Purchase Request"
              /> */}
              {/* <MenuPermission
                to="/comparative-slips"
                label="Comparative Slip"
              /> */}
              <MenuPermission
                key="purchase-orders"
                to="/purchase-orders"
                label="Purchase Order"
              />
              <MenuPermission
                key="stocks-receiving"
                to="/stocks-receiving"
                label="Warehouse Receipt"
              />
              <MenuPermission
                key="warehouse-transfer"
                to="/warehouse-transfer"
                label="Warehouse Transfer"
              />
              <MenuPermission
                key="production"
                to="/production"
                label="Production"
              />
              <MenuPermission
                key="delivery-receipts"
                to="/delivery-receipts"
                label="Delivery Receipts"
              />
              <MenuPermission
                key="purchase-returns"
                to="/purchase-returns"
                label="Purchase Returns"
              />
              {/* <MenuPermission
                to="/warehouse-withdrawals"
                label="Warehouse Withdrawals"
              />

              <MenuPermission to="/internal-repairs" label="Internal Repairs" /> */}
              {/* <MenuPermission to="/stock-transfers" label="Stock Transfers" /> */}
              {/* <MenuPermission
                to="/display-delivery-receipts"
                label="Display Delivery Receipts"
              />
              <MenuPermission
                to="/petty-cash-vouchers"
                label="Petty Cash Vouchers"
              />
              <MenuPermission to="/cash-sales" label="Cash Sales" />
              <MenuPermission to="/charge-sales" label="Charge Sales" />
              <MenuPermission
                to="/replacement-receipts"
                label="Replacement Form"
              /> */}
              <MenuPermission
                key="sales-returns"
                to="/sales-returns"
                label="Return Stock"
              />
              <MenuPermission
                key="credit-memos"
                to="/credit-memos"
                label="Credit Memos"
              />
              <MenuPermission
                key="debit-memos"
                to="/debit-memos"
                label="Debit Memos"
              />
              <MenuPermission
                key="inventory-adjustments"
                to="/inventory-adjustments"
                label="Inventory Adjustments"
              />
              <MenuPermission
                key="physical-counts"
                to="/physical-counts"
                label="Physical Count"
              />
              <MenuPermission
                key="customer-collections"
                to="/customer-collections"
                label="Customer Collections"
              />
              <MenuPermission
                key="check-vouchers"
                to="/check-vouchers"
                label="Disbursement Voucher"
              />
              <MenuPermission key="issuance" to="/issuance" label="Issuance" />
            </SubMenu>
            <SubMenu
              key="ar-reports"
              title={
                <span>
                  <span>
                    <i className="fas fa-folder-open"></i>
                  </span>
                  A/R Reports
                </span>
              }
            >
              <MenuPermission
                key="customer-collection-report"
                to="/reports/customer-collection-report"
                label="Collection Report"
              />
              <MenuPermission
                key="customer-aging-summary"
                to="/reports/customer-aging-summary"
                label="Customer Aging Summary"
              />
              <MenuPermission
                key="customer-aging-details"
                to="/reports/customer-aging-details"
                label="Customer Aging Details"
              />

              <MenuPermission
                key="purchase-request-report"
                to="/reports/purchase-request-report"
                label="Purchase Request Report"
              />
              <MenuPermission
                key="stocks-receiving-report"
                to="/reports/stocks-receiving-report"
                label="Warehouse Receipt Report"
              />
              <MenuPermission
                key="purchase-order-report"
                to="/reports/purchase-order-report"
                label="Purchase Order Report"
              />
              <MenuPermission
                key="warehouse-withdrawal-report"
                to="/reports/warehouse-withdrawal-report"
                label="Warehouse Withdrawal Report"
              />
              <MenuPermission
                key="return-stock-report"
                to="/reports/return-stock-report"
                label="Return Stock Report"
              />
              <MenuPermission
                key="inventory-adjustment-report"
                to="/reports/inventory-adjustment-report"
                label="Inventory Adjustment Report"
              />
              <MenuPermission
                key="physical-count-report"
                to="/reports/physical-count-report"
                label="Physical Count Report"
              />
              <MenuPermission
                key="check-voucher-report"
                to="/reports/check-voucher-report"
                label="Disbursement Voucher Report"
              />
              <MenuPermission
                key="production-history"
                to="/reports/production-history"
                label="Production History Report"
              />
              <MenuPermission
                key="processed-report"
                to="/reports/processed-report"
                label="Processed Report"
              />
              <MenuPermission
                key="issuance-report"
                to="/reports/issuance-report"
                label="Issuance Report"
              />
              <MenuPermission
                key="delivery-receipts-report"
                to="/reports/delivery-receipts-report"
                label="Deliveries Report"
              />
              <MenuPermission
                key="delivery-receipt-items-report"
                to="/reports/delivery-receipt-items-report"
                label="Delivery Receipt Items Report"
              />
              <MenuPermission
                key="warehouse-receipt-items-report"
                to="/reports/warehouse-receipt-items-report"
                label="Warehouse Receipt Items Report"
              />
            </SubMenu>
            <SubMenu
              key="inventory-reports"
              title={
                <span>
                  <span>
                    <i className="fas fa-folder-open"></i>
                  </span>
                  Inventory Reports
                </span>
              }
            >
              <MenuPermission
                key="branch-inventory-balance-list"
                to="/reports/branch-inventory-balance-list"
                label="Branch Inventory List"
              />
              <MenuPermission
                key="stock-card-report"
                to="/reports/stock-card-report"
                label="Stock Card Report"
              />
              <MenuPermission
                key="daily-ledger-report"
                to="/reports/daily-ledgers-report"
                label="Daily Ledger Report"
              />

              <MenuPermission
                key="daily-inventory-ledger-report"
                to="/reports/daily-inventory-ledgers-report"
                label="Daily Inventory Ledger Report"
              />
              <MenuPermission
                key="statement-of-account"
                to="/reports/statement-of-account"
                label="Statement of Accounts"
              />
              <MenuPermission
                to="/reports/all-sales-listings"
                label="All Sales Listings"
              />
              <MenuPermission
                to="/reports/xread-listings"
                label="Xread Listings"
              />
              <MenuPermission
                to="/reports/zread-listings"
                label="Zread Listings"
              />
              <MenuPermission
                to="/reports/category-sales-report"
                label="Category Sales Report"
              />
              <MenuPermission
                to="/other-payment-listings"
                label="Cashless Payments Report"
              />
              <MenuPermission
                to="/sales-channel-sales-per-period-covered"
                label="Sales Channel Sales Per Period Covered"
              />
              <MenuPermission
                to="/payment-method-per-sales-channel"
                label="Payment Method Per Sales Channel"
              />
              <MenuPermission
                to="/reports/average-sales-per-pax-per-day"
                label="Average Sales per Pax/Day"
              />
              <MenuPermission
                to="/reports/branch-inventory-report"
                label="Branch Inventory Report"
              />
            </SubMenu>
            {/* <SubMenu
              key="inventory-reports"
              title={
                <span>
                  <span>
                    <i className="fas fa-folder-open"></i>
                  </span>
                  Inventory Reports
                </span>
              }
            >
              <MenuPermission
                to="/reports/branch-inventory-balance-list"
                label="Branch Inventory List"
              />
              <MenuPermission
                to="/reports/stock-card-report"
                label="Stock Card Report"
              />
              <MenuPermission
                to="/reports/stocks-receiving-history"
                label="Warehouse Receipt Report"
              />
              <MenuPermission
                to="/reports/stock-transfer-history"
                label="Stock Transfer Report"
              />
              <MenuPermission
                to="/reports/replacement-history"
                label="Replacement Report"
              />
              <MenuPermission
                to="/reports/return-stock-report"
                label="Return Stock Report"
              />
              <MenuPermission
                to="/reports/petty-cash-voucher-report"
                label="Petty Cash Voucher Report"
              />
              <MenuPermission
                to="/reports/credit-memos-history"
                label="Credit Memo Report"
              />
              <MenuPermission
                to="/reports/statement-of-account"
                label="Statement of Accounts"
              />
              <MenuPermission
                to="/reports/old-statement-of-account"
                label="Old Statement of Accounts"
              />
              <MenuPermission
                to="/reports/category-sales-report"
                label="Category Sales Report"
              />
              <MenuPermission
                to="/reports/cash-sales-report"
                label="Cash Sales Report"
              />
              <MenuPermission
                to="/reports/charge-sales-report"
                label="Charge Sales Report"
              />
              <MenuPermission
                to="/reports/customer-collection-report"
                label="Collection Report"
              />
              <MenuPermission
                to="/reports/customer-aging-summary"
                label="Customer Aging Summary"
              />
              <MenuPermission
                to="/reports/customer-aging-details"
                label="Customer Aging Details"
              />
              <MenuPermission
                to="/reports/account-ledger-summary"
                label="Account Ledger Summary"
              />
              <MenuPermission
                to="/reports/account-ledger"
                label="Account Ledger"
              />
            </SubMenu> */}

            {/* <MenuPermission
              to="/account-settings"
              icon="fa-cog"
              label="Settings"
            /> */}

            {auth.user.username === "msalvio" && (
              <Menu.Item key="menu-routes">
                <Link to="/menu-routes">
                  <span>
                    <i className={`fas fa-folder-open`}></i>
                    Menu Routes
                  </span>
                </Link>
              </Menu.Item>
            )}

            <MenuPermission
              key="account-settings"
              to="/account-settings"
              icon="fas fa-folder-open"
              label="Setting"
            />

            <SubMenuPermission
              key="user-management"
              to="/user-management"
              title={
                <span>
                  <i className="fas fa-users-cog"></i>
                  User Management
                </span>
              }
            >
              <MenuPermission key="roles" to="/roles" label="Roles" />
              <MenuPermission
                key="users"
                to="/users"
                icon="fa-users"
                label="Users"
              />
              <MenuPermission
                key="permissions"
                to="/permissions"
                icon="fa-user-cog"
                label="Permissions"
              />
            </SubMenuPermission>

            <MenuPermission
              key="update-password"
              to="/update-password"
              icon="fa-lock"
              label="Update Password"
            />
          </Menu>

          <Button
            className="logout-button"
            icon={
              <i
                className="fa-solid fa-key pad-right-8"
                style={{ color: "#ff8e26" }}
              ></i>
            }
            onClick={() => {
              logoutUser();
            }}
          >
            Logout
          </Button>
        </Sider>
        <Layout style={{ marginLeft: 200, backgroundColor: "black" }}>
          <Content style={{ overflow: "auto" }}>
            <Component {...rest} />
          </Content>
          <Footer
            style={{
              textAlign: "center",
              backgroundColor: "#EE303E",
              color: "black",
              borderRadius: "10px 10px 0 0",
              marginRight: 18,
              marginTop: 3,
              fontSize: "10px",
            }}
          >
            ©2025 - powered by{" "}
            <span className="has-text-weight-bold">
              msalvio software & hardware technologies
            </span>
          </Footer>
        </Layout>
      </Layout>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logoutUser })(MenuComponent);
